import { getBlob, ref } from "firebase/storage";
import { storage } from "./firebase";
import { MAX_EVENT_FLYER_BYTES } from "./eventMedia";

export async function loadEventFlyerBlob(storagePath) {
  return getBlob(ref(storage, storagePath), MAX_EVENT_FLYER_BYTES);
}
